import React, { Component } from 'react';
class ValueSystem extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  componentDidMount() {

  }


  render() {
    return (
        <div className="container-xxl py-5 inner_con_grey"id="value">
            <div className="container inner_con">
              <h1 className="text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">Value System</h1>
                <div className="row g-4">
                    <div className="col-lg-12 wow fadeIn inner_con_grey" data-wow-delay="0.5s">
                         <p className="mb-4">At <b>Bylaws India</b>, our values define our ethos and drive our practice:</p>
                         <p><b>Our Quintessential Values</b></p>
                         <p><b>B – Bravura</b></p>
                         <p>We exhibit exceptional courage and sophistication in navigating intricate legal challenges.</p>
                         <p><b>Y – Yield-Focused</b></p>
                         <p>Our unwavering commitment is to deliver outcomes that resonate with our clients’ aspirations.</p>
                         <p><b>L – Luminary</b></p>
                         <p>We strive to illuminate the path in complex legal terrains, setting unparalleled benchmarks.</p>
                         <p><b>A – Astuteness</b></p>
                         <p>With razor-sharp insight and adaptability, we tailor strategies to the ever-evolving legal landscape.</p>
                         <p><b>W – Wisdom</b></p>
                         <p>Rooted in profound knowledge and judicious expertise, we render solutions that inspire trust and excellence.
These values epitomize Bylaws India’s ethos, underscoring our commitment to sophistication, ingenuity and distinction.</p>

                     </div>
                </div>
            </div>
        </div>
    );
  }
}

export default ValueSystem;
